import {
  ColDef,
  ICellRendererParams,
  ITooltipParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { MASTER_DATA_FORM_FIELDS } from 'utils/constants'
import { getDepartment, getFamily, getSection } from 'utils/helpers'

const {
  BARCODE,
  DEPARTMENT,
  SECTION,
  FAMILY,
  SUB_FAMILY,
  ERP_ITEM_DESC,
  ONLINE_DESC,
  VAT_CLASS,
  ACTIVE_ONLINE,
  IS_DISABLE,
} = MASTER_DATA_FORM_FIELDS

const yesNoRenderer = (params: ICellRendererParams) =>
  params?.value === true ? 'Yes' : params?.value === false ? 'No' : '-'

type BundleItemSummary = { catalogue: string; quantity?: number }

const formatBundleItem = (item: BundleItemSummary) =>
  item.quantity && item.quantity > 1
    ? `${item.catalogue} x${item.quantity}`
    : item.catalogue

export const bundleProductColumns: ColDef[] = [
  {
    headerName: BARCODE.label,
    field: '_id',
    minWidth: 150,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_ITEM_DESC.label,
    field: ERP_ITEM_DESC.key,
    minWidth: 220,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ONLINE_DESC.label,
    field: ONLINE_DESC.key,
    minWidth: 220,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: DEPARTMENT.label,
    field: DEPARTMENT.key,
    valueFormatter: (params: ValueFormatterParams) =>
      getDepartment(params.value),
  },
  {
    headerName: SECTION.label,
    field: SECTION.key,
    valueFormatter: (params: ValueFormatterParams) => getSection(params.value),
  },
  {
    headerName: FAMILY.label,
    field: FAMILY.key,
    valueFormatter: (params: ValueFormatterParams) => getFamily(params.value),
  },
  {
    headerName: SUB_FAMILY.label,
    field: SUB_FAMILY.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: VAT_CLASS.label,
    field: VAT_CLASS.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Items',
    field: 'bundleItems',
    minWidth: 150,
    valueFormatter: (params: ValueFormatterParams) => params.value?.length ?? 0,
    tooltipValueGetter: (params: ITooltipParams) =>
      (params.value as BundleItemSummary[] | undefined)
        ?.map(formatBundleItem)
        .join(', ') || undefined,
  },
  {
    headerName: 'Price',
    field: 'pricing.price',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value !== undefined && params.value !== null ? params.value : '-',
  },
  {
    headerName: 'Special Price',
    field: 'pricing.specialPrice',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value !== undefined && params.value !== null ? params.value : '-',
  },
  {
    headerName: ACTIVE_ONLINE.label,
    field: ACTIVE_ONLINE.key,
    cellRenderer: yesNoRenderer,
  },
  {
    headerName: IS_DISABLE.label,
    field: IS_DISABLE.key,
    cellRenderer: yesNoRenderer,
  },
]
